export const createEvent = (type: string, properties: any = {}) => ({
  type,
  target: null,
  preventDefault: null,
  stopPropagation: null,
  ...properties,
});
